"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryProgress = void 0;
const React = require("react");
const material_1 = require("@mui/material");
const styles_1 = require("@mui/styles");
const useSalesOrderDetailsForStatus_1 = require("../../../hooks/useSalesOrderDetailsForStatus");
const styles = require("./styles.scss");
const mobileStepperStyles = {
    root: {
        backgroundColor: styles.colorSecondary,
        padding: 0
    },
    progress: {
        height: 16,
        backgroundColor: styles.colorPrimary,
        width: "0%"
    },
    barColorPrimary: {
        backgroundColor: styles.colorPrimary
    },
    barColorSecondary: {
        backgroundColor: styles.colorSecondary
    },
    bar1Determinate: {
        backgroundColor: styles.colorPrimary
    },
    bar1Indeterminate: {
        backgroundColor: styles.colorTertiary
    },
    bar2Indeterminate: {
        backgroundColor: styles.colorTertiary
    }
};
const SalesOrderSummaryProgress = ({ salesOrder }) => {
    const { completed } = salesOrder;
    const { statusesCount, currentStatusStep, statusProgress } = (0, useSalesOrderDetailsForStatus_1.useSalesOrderDetailsForStatus)(salesOrder);
    mobileStepperStyles.progress.width = statusProgress;
    const useStyles = (0, styles_1.makeStyles)(mobileStepperStyles);
    const styles = useStyles();
    return (React.createElement(material_1.MobileStepper, { variant: "progress", steps: statusesCount, position: "static", activeStep: currentStatusStep, backButton: null, nextButton: null, classes: {
            root: styles.root,
            progress: styles.progress
        }, LinearProgressProps: {
            variant: completed ? "determinate" : "indeterminate",
            classes: {
                barColorPrimary: styles.barColorPrimary,
                barColorSecondary: styles.barColorSecondary,
                bar1Determinate: styles.bar1Determinate,
                bar1Indeterminate: styles.bar1Indeterminate,
                bar2Indeterminate: styles.bar2Indeterminate
            }
        } }));
};
exports.SalesOrderSummaryProgress = SalesOrderSummaryProgress;
//# sourceMappingURL=index.js.map